import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { constantsData, identifiersData, namesData, statusTypesData, urlsData } from "@/data";
import { useApisClient } from "@/hooks";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useEditDriveManagementLabel = () => {
    const [loading, setLoading] = useState(false);

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const { logout } = useAuth0();

    const { post } = useApisClient();

    const {
        files: { url: driveManagementFilesApiUrl },
        labels: driveManagementLabelsApiUrl,
    } = urlsData.apis.driveManagement;

    const { editDriveManagementLabelPending: editDriveManagementLabelPendingToastName } = namesData.toasts;

    const { toast: toastId } = identifiersData.ids;

    const editDriveManagementLabel = (id, labelId, fieldModifications) => {
        setLoading(true);

        post(`${driveManagementFilesApiUrl}/${driveManagementLabelsApiUrl}`, id, {
            labelModifications: [
                {
                    fieldModifications,
                    labelId,
                },
            ],
        })
            .then(() => {
                dispatch(
                    openAlert(t("messages.saveMsgs.success", { entity: t("labels.label") }), statusTypesData.success),
                );
            })
            ["catch"]((err) => {
                displayErrorHandler(
                    err.response.data.message === constantsData.networkError
                        ? t("messages.networkFailure")
                        : err.response.data.message,
                    dispatch,
                    openAlert,
                    err.response.status,
                    logout,
                );
            })
            ["finally"](() => {
                toast.dismiss(`${editDriveManagementLabelPendingToastName}_${toastId}`);

                setLoading(false);
            });
    };

    useEffect(
        () => {
            if (loading) {
                toast.info(() => t("messages.saveMsgs.pending", { entity: t("labels.label") }), {
                    toastId: `${editDriveManagementLabelPendingToastName}_${toastId}`,
                });
            }
        },
        [loading], //eslint-disable-line
    );

    return {
        editDriveManagementLabel,
        loading,
    };
};

export default useEditDriveManagementLabel;
